import React from "react";
import { t } from "@lingui/macro";

const More = () => {
  return (
    <div>
      <h2>{t`More`}</h2>
      <p>{t`Access additional features and settings.`}</p>
    </div>
  );
};

export default More;
